module.exports = __webpack_public_path__ + "static/img/company-default-bg.c29c7fab.png";